// extracted by mini-css-extract-plugin
export default {"root":"region-select_root__B3YTq","select":"region-select_select__JNMJ1","text":"region-select_text__SO2qb"};